import utils from '@/utils';
import { Product } from 'schema-dts';

// @ts-check

/**
 * @type { Product }
 * @class
 */
export default class ProductSchema {
    /**
     * @constructor
     * @param {Object} productDetails
     */
    constructor(productDetails = {}) {
        const { getSafe } = utils;
        const price = productDetails.price || {};
        const ratingInfo = productDetails.ratingInfo || {};
        const variants = productDetails.available && productDetails.directBooking
            ? (productDetails.variantsWithScheduledArrival || []).flatMap(v => v.variants || [])
            : productDetails.variants || [];

        let minimumPrice =
            Math.min(
                ...[
                    getSafe(price, 'regularPriceValues.minimumPerPersonPerNightPrice.perPersonPerNightPrice'),
                    getSafe(price, 'regularPriceValues.minimumPerPersonPrice.perPersonPrice'),
                    getSafe(price, 'regularPriceValues.minimumPrice.price')
                ].filter(Number)
            ) / 100;
        minimumPrice = isFinite(minimumPrice) ? minimumPrice : 0;

        const maximumPrice =
            variants.reduce((acc, variant) => {
                const nightPrice = getSafe(variant, 'price.regularPriceValues.perPersonPerNightPrice');
                const personPrice = getSafe(variant, 'price.regularPriceValues.perPersonPrice');
                const packagePrice = getSafe(variant, 'price.regularPriceValues.price');
                acc = Math.max(acc, nightPrice || personPrice || packagePrice);
                return acc;
            }, 0) / 100;

        this['@context'] = 'https://schema.org';
        this['@type'] = 'Product';
        //this.id = productDetails.id; // validator complains about it!
        this.name = productDetails.title;
        this.description = productDetails.description;
        this.sku = productDetails.id;

        this.offers = {
            '@type': 'AggregateOffer',
            lowPrice: minimumPrice, // sold out will give 0, required field
            highPrice: maximumPrice,
            priceCurrency: 'EUR',
            availability: productDetails.soldOut ? 'https://schema.org/SoldOut' : 'https://schema.org/InStock'
        };

        if (ratingInfo.enabled) {
            this.aggregateRating = {
                '@type': 'AggregateRating',
                ratingValue: ratingInfo.value * 100,
                bestRating: 100,
                worstRating: 0,
                ratingCount: ratingInfo.reviewCount
            };
        }
    }
}
